import { createPortal } from "react-dom";

/* CSS */
import styles from './ConfirmationModal.module.css';
import shared from '../../styles/shared.module.css';

const ConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    children,
    confirmText = "Confirm",
    cancelText = "Cancel",
    isDanger = false,   // If true, make confirm button red
    isSuccess = false,  // If true, make confirm button blue
    showCancel = true,  // Cases for only one button
    customIcon = null,   // Optional custom icon component
    customActions = null,
    customWidth = null // Optional custom width string like '400px'
}) => {

    if (!isOpen) return null;

    // Determine if we should center the button
    const isSingleButton = !showCancel && !customActions;

    return createPortal(
        <div className={shared.modalOverlay} data-modal-overlay>
            <div className={shared.modalContent} style={customWidth ? { width: customWidth } : {}}>

                {title && <h2 className={styles.modalTitle}>{title}</h2>}
                {message && <p className={styles.modalMessage}>{message}</p>}

                {/* Render custom children */}
                {children && <div className={styles.modalChildren}>{children}</div>}

                <div className={styles.modalIconWrapper}>
                    {customIcon &&
                        <div className={styles.modalIcon}>{customIcon}</div>
                    }
                </div>

                <div className={`${styles.modalActions} ${isSingleButton ? styles.centered : ''}`}>
                    {customActions ? (
                        customActions
                    ) : (
                        <>
                            {showCancel && <button onClick={onClose} className={`${shared.modalButton} ${shared.secondary}`}>{cancelText}</button>}
                            <button
                                onClick={onConfirm}
                                className={`${shared.modalButton} ${isDanger ? shared.danger : isSuccess ? shared.success : shared.primary}`}
                            >
                                {confirmText}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
}

export default ConfirmationModal;